import { getHttpApi } from '@cian/http-api/browser';
import { fetchSuggest, ISuggestRequest, TSuggestResponse } from '../../../repositories/geo-suggest/v2/suggest';

export async function getSearchAutocomplete(parameters: ISuggestRequest) {
  try {
    const httpApi = getHttpApi();

    const { response, statusCode }: TSuggestResponse = await fetchSuggest({
      httpApi,
      parameters,
    });

    if ('errors' in response || statusCode !== 200) {
      throw response;
    }

    return response;
  } catch (error) {
    throw error;
  }
}
